import { CommonModule } from '@angular/common';
import { Component, inject, input, type Signal } from '@angular/core';
import { GeneralActions } from '@hunting-nature/Secacam/shared/redux/general/general.actions';
import { GeneralSelectors } from '@hunting-nature/Secacam/shared/redux/general/general.reducer';
import { pickIcons } from '@hunting-nature/shared-ui/helper/icon-registry.const';
import { IonIcon } from '@ionic/angular/standalone';
import { Store } from '@ngrx/store';
import { addIcons } from 'ionicons';

import { TabBarActions } from '../../../redux/tab-bar/tab-bar.actions';

@Component({
  selector: 'app-tab-bar-fab',
  templateUrl: './tab-bar-fab.component.html',
  styleUrls: ['./tab-bar-fab.component.scss'],
  standalone: true,
  imports: [IonIcon, CommonModule],
})
export class TabBarFabComponent {
  private readonly store = inject(Store);

  // inputs
  isMenuOpen = input<boolean>(false);

  // private properties
  private readonly isOfflineMode$$: Signal<boolean> = this.store.selectSignal(GeneralSelectors.isOfflineMode);

  constructor() {
    addIcons(pickIcons('menu-plus'));
  }

  handleToggle(): void {
    if (this.isOfflineMode$$()) {
      this.store.dispatch(GeneralActions.openOfflineModal());
      return;
    }

    this.store.dispatch(TabBarActions.toggleTabBarMenu());
  }
}
